import { list20000Sprint04 } from '../ActivityLists/AL20000Sprint04'
import { list20000Sprint05 } from '../ActivityLists/AL20000Sprint05'

import { tUnderConstruction } from './SL00000Sprint00'

// Introduction to Computer Science (ICS) sprint 5 global values.
const sprint = 5
const activityList = () => { return list20000Sprint05(sprint) }
const activityListPrevious = () => { return list20000Sprint04(sprint-1) }

// Todo: Remove export from next line
export const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_5_1of4 = () => { return [ tUnderConstruction ] }

// Session 2 of 4: Thursday
const ics_5_2of4 = () => { return [ tUnderConstruction ] }

// Session 3 of 4: Tuesday
const ics_5_3of4 = () => { return [ tUnderConstruction ] }

// Session 4 of 4: Thursday
const ics_5_4of4 = () => { return [ tUnderConstruction ] }

export const ics_5_slidedeckTTR = [ ics_5_1of4, ics_5_2of4, ics_5_3of4, ics_5_4of4 ]